import type React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { SearchAlertFilters } from '@xing-com/crate-jobs-helpers';
import { Tag } from '@xing-com/tag';
import { spaceM, spaceS } from '@xing-com/tokens';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spaceM} ${spaceS};
`;

const Highlight = styled.span`
  font-weight: 700;
  filter: grayscale(100%) contrast(300%);
`;

const locationValue = (location: string, radius?: number | null): string =>
  `${location}${radius ? ` (${radius} km)` : ''}`;

type Props = { query: SearchAlertFilters };

export const FiltersSummary: React.FC<Props> = ({ query }) => {
  const { keywords, location, filter } = query;
  const { discipline } = filter ?? {};

  return (
    <Container>
      {keywords ? (
        <Tag>
          <FormattedMessage id="JOBS_CREATE_SEARCH_ALERT_KEYWORDS" />:{' '}
          <Highlight>{keywords}</Highlight>
        </Tag>
      ) : null}

      {location ? (
        <Tag>
          <FormattedMessage id="JOBS_CREATE_SEARCH_ALERT_LOCATION" />:{' '}
          <Highlight>
            {locationValue(location.text ?? '', location.radius)}
          </Highlight>
        </Tag>
      ) : null}
      {discipline ? (
        <Tag>
          <FormattedMessage id="JOBS_CREATE_SEARCH_ALERT_DISCIPLINE" />:{' '}
          <Highlight>{discipline.localizationValue}</Highlight>
        </Tag>
      ) : null}
    </Container>
  );
};
